import React from 'react';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import fr from 'facet-rest';
import Uploader from 'Components/Files/MessageAttachments/Uploader';
import IconButton from '@material-ui/core/IconButton';
import { addQuery } from 'Helpers/Query';
import PropTypes from 'prop-types';

const UploadImageButton = ({ resource, onClick }) => {
  const uploadImageUrl = resource.relationship(fr.relationships.uploadImage.name)?.link('related').url();
  const imageUrl = resource.relationship(fr.relationships.image.name)?.link('related').url();

  const handleSuccess = () => {
    addQuery({ refreshCuratedContentArticles: true });
  };

  return (
  // This onClick stops propagation of the event to the table row
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={onClick}>
      <Uploader
        url={uploadImageUrl}
        successToastMessage="Uploaded image"
        onSuccess={handleSuccess}
      >
        {imageUrl ? (
          <img src={imageUrl} style={{ height: 30, maxWidth: '100%' }} />
        ) : (
          <IconButton size="small">
            <AddAPhotoIcon />
          </IconButton>
        )}
      </Uploader>
    </div>
  );
};

UploadImageButton.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

const uploadImageAction = {
  columnName: 'Upload Image',
  component: UploadImageButton,
  onSubmit: async () => {
    // no-op
  },
  stopPropagation: true,
};

export default uploadImageAction;
